import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMyWeddings, type Wedding } from 'weddings/api/weddings'
import { WeddingKeys } from './queryKeys'

type UseMyWeddingsOptions = Omit<
  UseQueryOptions<Array<Wedding>, unknown, Array<Wedding>, ReturnType<typeof WeddingKeys.mine>>,
  'queryKey' | 'queryFn'
>

function useMyWeddings(
  options?: UseMyWeddingsOptions,
): UseQueryResult<Array<Wedding>, unknown> {
  return useQuery({
    ...options,
    queryKey: WeddingKeys.mine(),
    queryFn: getMyWeddings,
  })
}

export default useMyWeddings
